import { Card, CardBody, Chip } from '@heroui/react';
import { useTranslation } from 'react-i18next';

export default function Process() {
  const { t } = useTranslation();
  const steps = t('home.process.items', { returnObjects: true }) as Array<{
    number: string;
    title: string;
    description: string;
  }>;
  const stepIcons = [
    'ri-message-3-line',
    'ri-draft-line',
    'ri-code-box-line',
    'ri-rocket-2-line',
  ];

  return (
    <section className="relative z-10 overflow-hidden bg-transparent py-24 text-[#241b12]">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center md:mb-20">
          <Chip
            variant="flat"
            className="mb-5 border border-brand-green/20 bg-[rgba(255,248,241,0.82)] px-4 py-2 text-sm font-semibold text-brand-green"
            startContent={
              <span className="mr-2 inline-flex items-center">
                <i className="ri-shake-hands-line text-base" />
              </span>
            }
          >
            {t('home.process.badge')}
          </Chip>
          <h2 className="mb-6 text-5xl font-caprasimo text-[#241b12] md:text-6xl">
            {t('home.process.title')}
          </h2>
          <p className="mx-auto max-w-3xl text-lg leading-relaxed text-[#745f4d] md:text-xl">
            {t('home.process.description')}
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-0 right-0 top-[4.5rem] hidden h-px bg-gradient-to-r from-transparent via-brand-green/25 to-transparent lg:block" />

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="group relative h-full"
              >
                <Card className="h-full rounded-[28px] border border-[rgba(212,166,126,0.34)] bg-[rgba(255,247,239,0.9)] text-[#241b12] shadow-[0_16px_36px_rgba(106,67,33,0.08)] transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-green/30 hover:shadow-[0_24px_44px_rgba(106,67,33,0.12)]">
                  <CardBody className="flex h-full flex-col gap-6 p-7 text-[#241b12]">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-green text-[#0d0d0d] shadow-[0_14px_30px_rgba(163,230,53,0.2)] transition-transform duration-300 group-hover:scale-105">
                        <i className={`${stepIcons[index] ?? 'ri-arrow-right-line'} text-[1.7rem]`} />
                      </div>
                      <span className="rounded-full bg-[rgba(245,201,164,0.5)] px-3 py-1 text-xs font-semibold tracking-[0.16em] text-[#8a6545]">
                        {step.number}
                      </span>
                    </div>

                    <div className="space-y-4">
                      <h3 className="text-[1.5rem] font-caprasimo leading-tight text-[#241b12] transition-colors duration-300 group-hover:text-brand-green">
                        {step.title}
                      </h3>
                      <p className="text-sm leading-7 text-[#745f4d] md:text-[15px]">
                        {step.description}
                      </p>
                    </div>

                    <div className="mt-auto flex items-center gap-2 pt-1 text-sm font-medium text-[#775b42]">
                      <span>
                        {step.number}
                        {t('home.process.stepSuffix')}
                      </span>
                      <i className="ri-arrow-right-line text-[#775b42] transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
